import { useIntl } from 'react-intl';
import { KeyboardShortcut } from '@rossum/components/keyboard-shortcut/KeyboardShortcut';
import { IconTrash } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';

type DeleteButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

export const DeleteButton = ({ disabled, onClick }: DeleteButtonProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      title={
        disabled ? (
          ''
        ) : (
          <KeyboardShortcut
            description={intl.formatMessage({
              id: 'components.documentValidation.validationDialog.button.delete.tooltip',
            })}
          />
        )
      }
      key="delete-button"
    >
      <IconButton
        color="secondary"
        size="medium"
        data-cy="validation-dialog-delete"
        onClick={onClick}
        disabled={disabled}
        sx={{ p: 0.5, minWidth: 0 }}
      >
        <SvgIcon fontSize="large">
          <IconTrash />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
